var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} // TEST!!! Entire file is untested
import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from "../UI";

const List = ({ children }) => /*#__PURE__*/_jsx("div", { className: "item-group" }, void 0, children);

const ItemName = ({ children }) => /*#__PURE__*/
_jsx("div", { className: "item-name" }, void 0, /*#__PURE__*/
_jsx("span", {}, void 0, children)
);


const ItemFooter = ({ children, onClick }) => /*#__PURE__*/
_jsx("div", { className: "item-actions", onClick: onClick }, void 0,
children
);


const ProgressBar = ({ progress }) => {
  let message = `${progress} % Completed`;
  let icon = 'upload';
  if (progress === 0 || progress === 100) {
    message = 'Processing...';
    icon = 'clock';
  }
  return (/*#__PURE__*/
    _jsx("div", { className: "label-progress" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "label label-info" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: icon }), " ", /*#__PURE__*/_jsx("span", {}, void 0, message)
    ), /*#__PURE__*/
    _jsx("div", { className: "progress" }, void 0, /*#__PURE__*/
    _jsx("div", {
      className: "progress-bar progress-bar-striped active",
      style: { width: `${progress}%` } }
    )
    )
    ));

};

const ItemLabel = ({ children, status }) => {
  let icon = '';
  if (status === 'success') {
    icon = /*#__PURE__*/_jsx(Icon, { icon: "check" });
  }
  if (status === 'danger') {
    icon = /*#__PURE__*/_jsx(Icon, { icon: "times" });
  }
  if (status === 'warning') {
    icon = /*#__PURE__*/_jsx(Icon, { icon: "exclamation-triangle" });
  }
  return (/*#__PURE__*/
    _jsx("span", { className: `label label-${status || 'default'}` }, void 0,
    icon, " ", /*#__PURE__*/_jsx("span", {}, void 0, children)
    ));

};

ItemFooter.Label = ItemLabel;
ItemFooter.ProgressBar = ProgressBar;

const RowList = ({ children, zoomLevel = 0 }) => /*#__PURE__*/
_jsx("div", { className: `item-group item-group-zoom-${zoomLevel}` }, void 0, children);


const RowListItem = ({
  children,
  status,
  onClick,
  onMouseEnter,
  onMouseLeave,
  active,
  className
}) => {
  let activeClass = '';
  if (active === true) {
    activeClass = 'is-active';
  }
  if (active === false) {
    activeClass = 'is-disabled';
  }

  return (/*#__PURE__*/
    _jsx("div", {
      className: `${className} item item-status item-${status || 'default'} ${activeClass}`,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave }, void 0,

    children
    ));

};

RowList.Item = RowListItem;
























export { List, RowList, ItemFooter, ItemName };